import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './axios';
import moment from "moment";
import VeeValidate from 'vee-validate';
import infiniteScroll from 'vue-infinite-scroll'


Vue.use(infiniteScroll)
Vue.use(VeeValidate);
Vue.config.productionTip = false

Vue.filter('floatNumber', (number) => {
	if(number != null){
	let result = number.toFixed(1)
	  if (Number.isInteger(number)) {
	    result = number.toFixed(1)
	  }
	  return result
	}else{
		return 0
	}

});

Vue.filter('comma', (value) => {
	if (value != undefined) {
	  value = value.toString();
	  return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
	}
  });
  
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
